import React from "react";
import injectSheet from "react-jss";
import PropTypes from "prop-types";

import DescriptionListHeader from "./DescriptionListHeader";
import DescriptionListRow from "./DescriptionListRow";
import DescriptionListTerm from "./DescriptionListTerm";
import DescriptionListDefinition from "./DescriptionListDefinition";

const styles = ({ theme }) => ({
  root: {
    boxSizing: "border-box",
    margin: 0,
    fontFamily: theme.fonts.sans
  }
});

const DescriptionList = ({
  children,
  classes,
  zebra,
  column,
  balanced,
  separated,
  compact,
  themeId,
  ...other
}) => {
  /* removes null values */
  const filteredChildren = React.Children.toArray(children);
  return (
    <dl className={classes.root} {...other}>
      {React.Children.map(filteredChildren, child => {
        return React.cloneElement(child, {
          zebra,
          column,
          balanced,
          separated,
          compact,
          themeId
        });
      })}
    </dl>
  );
};

DescriptionList.Header = DescriptionListHeader;
DescriptionList.Row = DescriptionListRow;
DescriptionList.Term = DescriptionListTerm;
DescriptionList.Definition = DescriptionListDefinition;

DescriptionList.propTypes = {
  children: PropTypes.node,
  /** Display rows alternating in background color */
  zebra: PropTypes.bool,
  /** Display term and definition as columns, also gives some extra padding */
  column: PropTypes.bool,
  /** Splits the width between the term and definition evenly */
  balanced: PropTypes.bool,
  /** Display term and definition right after eachother */
  compact: PropTypes.bool,
  /** Display a border under each row */
  separated: PropTypes.bool,
  /** Theme ID used for styling the header row, overrides the 'zebra' property*/
  themeId: PropTypes.number
};

DescriptionList.defaultProps = {
  zebra: false,
  column: false,
  balanced: false,
  separated: false,
  themeId: undefined
};

export default injectSheet(styles, { inject: ["classes"] })(DescriptionList);
